import { HelpCircle } from "lucide-react";
import type { MouseEvent } from "react";

import { Tooltip, TooltipContent, TooltipTrigger } from "components/ui/tooltip";

const HINT_DELAY_MS = 200;

export interface HintIconProps {
  text: string;
  ariaLabel: string;
}

export function HintIcon({ text, ariaLabel }: HintIconProps): JSX.Element {
  const swallowParentAction = (event: MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation();
    event.preventDefault();
  };

  return (
    <Tooltip delayDuration={HINT_DELAY_MS}>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={ariaLabel}
          onClick={swallowParentAction}
          className="shrink-0 rounded-full text-muted-foreground/60 transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
        >
          <HelpCircle className="h-3 w-3" />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side="top"
        className="max-w-[16rem] text-xs font-normal normal-case"
      >
        {text}
      </TooltipContent>
    </Tooltip>
  );
}
